import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    start: String,
    end: String
  }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 15000) 
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    if (!this.hasStartValue || !this.startValue) {
      this.element.textContent = "-"
      return
    }

    const start = new Date(this.startValue)
    const end   = (this.hasEndValue && this.endValue) ? new Date(this.endValue) : new Date()

    let seconds = Math.floor((end - start) / 1000)
    if (seconds < 0) seconds = 0

    const mins = Math.floor(seconds / 60)
    const hrs  = Math.floor(mins / 60)
    const mm   = mins % 60

    this.element.textContent = hrs > 0 ? `${hrs}h ${mm}m` : `${mm}m`
  }
}
